module.exports = __webpack_public_path__ + "img/btn.4d6c3634.png";